import { useState, useContext, useEffect } from "preact/hooks";
import useWeightModal from "@/hooks/useWeightModal";
import { ProductContext } from "@/components/ProductCard";

function WeightSelectButton({ product, style="" }) {
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 990); // Set a default breakpoint for mobile view
	const {toggleModal, setModalProduct} = useWeightModal();
	const {toggleWeightSlideout} = useContext(ProductContext);

	useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 990);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); 

	function handleClick(event) {
		event.preventDefault();
		event.stopPropagation();

		if ( isMobile ) {
			toggleModal();
			setModalProduct(product);
		} else {
			toggleWeightSlideout();
		}
	}

	return (
		<button type="button" onClick={handleClick} className={`btn-primary-outline btn-add-to-cart ${style}`}>
			<span>Select Weight</span>
		</button>
	);
}
export default WeightSelectButton;
